console.log('CA swatches loaded');

document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.ca-swatch[data-ca-variant-id]');
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  const img = card.querySelector('img[data-ca-main-image]');
  const newSrc = swatch.getAttribute('data-ca-image');
  const variantId = swatch.getAttribute('data-ca-variant-id');

  // swap image (only works if variants have images)
  if (img && newSrc) {
    img.src = newSrc;
    img.srcset = '';
  }

  // update product links to include ?variant=
  const links = card.querySelectorAll('a[href*="/products/"]');
  links.forEach((a) => {
    try {
      const url = new URL(a.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      a.href = url.toString();
    } catch (err) {}
  });

  // selected ring
  const row = swatch.closest('[data-ca-swatches]');
  if (row) row.querySelectorAll('.ca-swatch').forEach((b) => b.classList.remove('is-selected'));
  swatch.classList.add('is-selected');
}, true);